module.exports = __webpack_public_path__ + "static/media/WW-Portfolio.8febf432.jpg";